import {IsInt, IsOptional, IsString} from 'class-validator';

export class VerifyOtpDto {
  @IsInt()
  code!: number;

  @IsString()
  key!: string;

  @IsOptional()
  @IsString()
  campaignCode?: string;
}
